export enum AuthWorkflowState {
  DefaultAuth = 'DefaultAuth',
  PrincipalAuth = 'PrincipalAuth',
  OasAuth = 'OasAuth',
  MsAuth = 'MsAuth',
  FullyAuthenticated = 'FullyAuthenticated',
  Error = 'Error',
}
